export default class TrainerAddController {
    constructor($routeParams, $location, userService, notificationsService, globalConstants) {
        this.$location = $location;
        this.userService = userService;
        this.notificationsService = notificationsService;
        this.clientId = $routeParams.clientId;
        this.user = {
            icon: 'default1.png'
        };
        this.imageProblem = false;
        this.emailExists = false;
        this.imageData = undefined;
        this.globalConstants = globalConstants;
    } 
 
    onSave() {

        var that = this;

        if(this.user.name == undefined || this.user.name.length < 1 || 
            this.user.email == undefined || this.user.email.length < 1 ||
            this.user.password == undefined || this.user.password.length < 1){
            this.notificationsService.show("Please enter a name, email and password", "error");
            return;
        }

        if(!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.user.email)){
            this.notificationsService.show("Please enter a valid email address", "error");
            return;
        }

        if(that.imageData != undefined) {
            that.user.image = that.imageData.image;
            that.user.imagetype = that.imageData.imagetype;
        }

        if(that.clientId)
        {
            that.user.clientId = that.clientId
        }
       
        that.userService.insertTrainer(that.user).then(resp => {

            this.whereToReturn();
            that.notificationsService.show("Trainer added", "success");
        }, resp => { 
            that.notificationsService.show(resp.data, "error");
        });
    }
 
    clearImageUpload() {
        document.getElementById('file').value = null;
        this.imageData = undefined; 
    }

    goBack(){
        this.whereToReturn();
    }

    whereToReturn()
    {
        if(this.clientId)  
        {
            this.$location.path('/manage/clients/edit/' + this.clientId);
        }
        else
        {
            this.$location.path('/manage');
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/components/trainers/trainers.add.controller.js